import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const Login = () => import('@/views/Login.vue');
const Layout = () => import('@/views/Layout.vue');
const UserList = () => import('@/views/UserList.vue');
const Reports = () => import('@/views/Reports.vue');

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          redirect: '/users'
        },
        {
          path: '/users',
          name: 'users',
          component: UserList
        },
        {
          path: '/reports',
          name: 'reports',
          component: Reports
        }
      ]
    }
  ]
});

router.beforeEach((to, _from, next) => {
  const token = window.sessionStorage.getItem('admin_token');
  if (to.path !== '/login' && !token) {
    next('/login');
    return;
  }
  next();
});

export default router;
